import { Container, Row, Col } from 'react-bootstrap';
import './sectionWithTwoCards.css';

function SectionWithTwoCards(props) {
  const { secTopContent, rightCardContent, leftCardContent } = props;

  return (
    <section>
      <Container>
        <div className="sec_with_two_cards">
          <Row className="justify-content-center">
            <Col md={7}>
              <div className="heading_header">{secTopContent || ''}</div>
            </Col>
            <Col md={6}>{leftCardContent || ''}</Col>
            <Col md={6}>{rightCardContent || ''}</Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default SectionWithTwoCards;
